import { useSelector } from "react-redux"
import { State } from "../reducers"
import { CatalogoProducto, Impuesto, ProductoImpuesto } from "../interfaces/utils/utils.interface"

const LISTA_EMPRESA_3DIGITOS = process.env.REACT_APP_EMPRESAS_3DIGITOS;

export const formatearNum = (numero: any) => {
  if (numero === "" || numero === null || numero === undefined) return "$0.00";
  return numero.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 3, style: 'currency', currency: 'USD'}) ?? '--'
}

export const formatearNumEmpresa = (numero: any, codigoEmpresa: string) => {
  if (numero === "" || numero === null || numero === undefined) return "$0.00";
  return numero.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(codigoEmpresa), style: 'currency', currency: 'USD'}) ?? '--'
}

export const isEmpresa3Digitos = (codigoEmpresa: string) => {
  let lista = LISTA_EMPRESA_3DIGITOS || '';
  for (let value of lista.split(',')) {
    if(value == codigoEmpresa) return true
  }
  return false
}

export const getDigitosCalculables = (codigoEmpresa: string) => {
  if(isEmpresa3Digitos(codigoEmpresa)){
    return 3
  } 
  return 2
}

export default function useUtilsDocs() {
  const { productos } = useSelector((state: State) => state.catalogos);

  return {
    esCatalogoProductoByTipo: 
      (esFormServicio: boolean, productoCatalogo: CatalogoProducto) => esCatalogoProductoByTipo(esFormServicio, productoCatalogo),
    processFormCatalogoProducto: 
      (tipoDte: string, form: any, codeProducto: string) => processFormCatalogoProducto(productos, tipoDte, form, codeProducto),
    processOtrosImpuestosCalculo: 
      (tipoDte: string, form: any, subtotal: number, esProductoForm: boolean = true) => processOtrosImpuestosCalculo(productos, tipoDte, form, subtotal, esProductoForm),
    procesOtrosImpuestosResumen: 
      (tipoDte: string, resumenActual: Array<any>, form: any, subtotal: number) => procesOtrosImpuestosResumen(productos, tipoDte, resumenActual, form, subtotal),
    getTributosCatalogoProducto:
      (codeProducto: string) => getTributosCatalogoProducto(productos, codeProducto),
    processDetalleImpuestosHTML:
      (tipoDte: string, form: any, subtotal: number) => processDetalleImpuestosHTML(productos, tipoDte, form, subtotal),
    getDigitosCalculables:
      (codigoEmpresa: string) => getDigitosCalculables(codigoEmpresa)
  };
}

export const esCatalogoProductoByTipo = (esFormServicio: boolean, productoCatalogo: CatalogoProducto): boolean => {
  return (
    esFormServicio && productoCatalogo.tipoitem === "0" // Servicio
  ) || (
    !esFormServicio && productoCatalogo.tipoitem === "1" // Producto
  );
};

export const getTributosCatalogoProducto = (productos: CatalogoProducto[], codeProducto: string):Array<string> => {
  if (!codeProducto || productos.length === 0) return [];
  
  const productSelected: CatalogoProducto|undefined = productos.find((producto: CatalogoProducto) => producto.clave === codeProducto);
  if (!productSelected) return [];

  const tributos = productSelected.ProductoImpuestos
    .map(({ Impuesto }: ProductoImpuesto) => (Impuesto.encuerpodoc ? Impuesto.codigo : ''))
    .filter(codigo => codigo !== '');
  
  return tributos;
}

export const processFormCatalogoProducto = (productos: CatalogoProducto[], tipoDte: string, form: any, codeProducto: string) => {
  let newFormProducto;
  const productSelected: CatalogoProducto|undefined = productos.find((producto: CatalogoProducto) => producto.clave === codeProducto);
  if (!productSelected) return form;

  const tributos = productSelected.ProductoImpuestos
    .map(({ Impuesto }: ProductoImpuesto) => (Impuesto.encuerpodoc ? Impuesto.codigo : null))
    .filter(codigo => codigo !== null);

  switch (tipoDte) {
    case "01":
    case "14":
      newFormProducto = {
        ...form,
        clave: productSelected.clave,
        tipoDescuento: productSelected.descuentoporcentaje ? "porcentaje" : "monto",
        descuento: productSelected.descuento ?? productSelected.descuentodefault,
        descripcion: productSelected.descripcion,
        tipo: productSelected.tipoitem === "0" ? "s" : "p",
        precio: productSelected.preciounitario ?? productSelected.preciounitariodefault,
        unidadMedida: productSelected.unidad,
        tributos: tributos,
      }
      break;

    case "03":
    case "04":
    case "05":
    case "06":
    case "11":
      newFormProducto = {
        ...form,
        clave: productSelected.clave,
        conIva: productSelected.ivaincluido,
        descripcion: productSelected.descripcion,
        descuento: productSelected.descuento ?? productSelected.descuentodefault,
        exento: productSelected.exento,
        servicio: productSelected.tipoitem === "0",
        tipoDescuento: productSelected.descuentoporcentaje ? "Porcentaje" : "Monto",
        precio: productSelected.preciounitario ?? productSelected.preciounitariodefault,
        unidadMedida: productSelected.unidad,
        tributos: tributos,
      }
      break;

    default:
      newFormProducto = { ...form };
      break;
  }

  return newFormProducto;
};

// Función auxiliar para calcular los tributos
export const calcularTributo = (tipoDte: string, form: any, subtotal: number, tributo: Impuesto) => {
  let totalTributo = 0;
  const valorImpuesto = parseFloat(`${tributo.impuesto}`);

  switch (tipoDte) {
    case "01":
    case "03":
    case "04":
    case "05":
    case "06":
      if (parseFloat(form.cantidad || 0) >= tributo.cantidadaplica) {
        if (tributo.esporcentaje) totalTributo += subtotal * (valorImpuesto / 100);
        else {
          const aplica = form.cantidad / tributo.cantidadaplica;
          for (let i = 0; i < aplica; i++) {
            totalTributo += valorImpuesto;
          }
        }
      }
      break;

    default:
      break;
  }
  
  return totalTributo;
};

// Función auxiliar para procesar otros impuestos cálculo
export const processOtrosImpuestosCalculo = (productos: CatalogoProducto[], tipoDte: string, form: any, subtotal: number, esProductoForm: boolean = true): number => {
  try {
    let totalTributos = 0;
    const productSelected: CatalogoProducto|undefined = productos.find((producto: CatalogoProducto) => producto.clave === form?.clave);

    if (!productSelected) return 0;
    for (const itemImpuesto of productSelected.ProductoImpuestos) {
      const tributo = itemImpuesto.Impuesto;

      // esProductoForm -> Si es el calculo en un formulario de producto o en el resumen de productos general
      const calculaTributo = esProductoForm ? tributo.enresumensitioprod : tributo.enresumensitiodoc;
      if (!calculaTributo) continue;

      totalTributos += calcularTributo(tipoDte, form, subtotal, tributo);
    }
    return totalTributos;
  } catch (e) {
    return 0;
  }
};

// Función auxiliar para procesar otros impuestos resumen
export const procesOtrosImpuestosResumen = (productos: CatalogoProducto[], tipoDte: string, resumenActual: Array<any>, form: any, subtotal: number): Array<string> => {
  try {
    const productSelected: CatalogoProducto|undefined = productos.find((producto: CatalogoProducto) => producto.clave === form?.clave);
    if (!productSelected) return resumenActual;

    for (const itemImpuesto of productSelected.ProductoImpuestos) {
      let totalTributo = 0;
      const tributo = itemImpuesto.Impuesto;

      if (!tributo.enresumen) continue;
      totalTributo += calcularTributo(tipoDte, form, subtotal, tributo);

      const tributoResumen = resumenActual.find((resum) => resum.codigo === tributo.codigo);
      if (!tributoResumen) {
        resumenActual.push({ codigo: tributo.codigo, valor: totalTributo, descripcion: tributo.descripcion });
      } else {
        tributoResumen.valor += totalTributo;
      } 
    }

    return resumenActual;
  } catch (e) {
    return resumenActual;
  }
};

// Función auxiliar para generar un detalle html para mostrar en la tabla de productos
export const processDetalleImpuestosHTML = (productos: CatalogoProducto[], tipoDte: string, form: any, subtotal: number): string => {
  let htmlTributos = "";
  try {
    const productSelected: CatalogoProducto|undefined = productos.find((producto: CatalogoProducto) => producto.clave === form?.clave);
    if (!productSelected) return htmlTributos;

    for (const itemImpuesto of productSelected.ProductoImpuestos) {
      let totalTributo = 0;
      const tributo = itemImpuesto.Impuesto;

      totalTributo += calcularTributo(tipoDte, form, subtotal, tributo);

      // Agregar html
      htmlTributos += `${tributo.descripcion}: $${totalTributo.toFixed(2)}<br/>`;
    }

    return `<p>${htmlTributos || 'N/A'}</p>`;
  } catch (e) {
    return `<p>N/A</p>`;
  }
};

